/**
 * Handle country modal display
 * @author Oliver Boermans
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'core/modules/country-modal';
const log = debug(MODULE_NAME);

const MODAL_SELECTOR = '#country-select-modal';
const STORAGE_KEY = 'USER_CLOSED_COUNTRY_MODAL';

function isStorageAvailable() {
    if (typeof sessionStorage === 'object') {
        try {
            sessionStorage.setItem('sessionStorageTested', 1);
            sessionStorage.getItem('sessionStorageTested');
        } catch (error) {
            log('sessionStorage is unavailable');
            return false;
        }
        return true;
    }
    return false;
}

function registerClosed() {
    log('Modal closed');
    sessionStorage.setItem(STORAGE_KEY, 'true');
}

function hasUserClosedModal() {
    const value = sessionStorage.getItem(STORAGE_KEY);
    log(STORAGE_KEY, value);
    return value === 'true';
}

function openModal(modal) {
    modal.foundation('open');
}

export function exec() {
    log('exec');
    $(function () {
        const $modal = $(MODAL_SELECTOR);

        //  Note modal may be ommitted server side cookie
        if (!$modal.length) {
            log('Modal is absent');
            return false;
        }

        //  if storage is not available open modal anyway
        if (isStorageAvailable() && !hasUserClosedModal()) {
            log('open modal');
            openModal($modal);
            $modal.on('closed.zf.reveal', registerClosed);
        } else if (!isStorageAvailable()) {
            openModal($modal);
        }
    });
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/country-modal/index.js